var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.todos),function(todo){return _c('li',{key:todo.id},[_c('TodoItem',{attrs:{"todo":todo},on:{"remove-item":_vm.removeItem}})],1)}))}
var staticRenderFns = []

export { render, staticRenderFns }